import { theme } from 'antd'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useMemo } from 'react'

export const Involvement = ({ involvementEr = 0, title = 'Вовлечённость ER', height = 350 }) => {
    const {
        token: { colorBgElevated, colorText }
    } = theme.useToken()

    const options = useMemo(() => {
        return {
            exporting: {
                enabled: false
            },
            chart: {
                type: 'gauge',
                plotBackgroundColor: colorBgElevated,
                plotBackgroundImage: null,
                plotBorderWidth: 0,
                plotShadow: false,
                height,
                borderRadius: 10,
                backgroundColor: colorBgElevated
            },
            title: {
                text: title,
                style: { color: colorText }
            },
            pane: {
                startAngle: -90,
                endAngle: 89.9,
                background: null,
                center: ['50%', '75%'],
                size: '100%'
            },
            yAxis: {
                min: 0,
                max: 100,
                tickPixelInterval: 72,
                tickPosition: 'inside',
                tickColor: colorText,
                tickLength: 20,
                tickWidth: 2,
                minorTickInterval: null,
                labels: {
                    distance: 20,
                    style: {
                        fontSize: '14px',
                        color: colorText
                    }
                },
                lineWidth: 0,
                plotBands: [
                    {
                        from: 0,
                        to: 5,
                        color: '#A82A2AFF',
                        thickness: 20
                    },
                    {
                        from: 5,
                        to: 15,
                        color: '#AFC019FF',
                        thickness: 20
                    },
                    {
                        from: 15,
                        to: 30,
                        color: '#69A75FFF',
                        thickness: 20
                    },
                    {
                        from: 30,
                        to: 100,
                        color: '#26A715FF',
                        thickness: 20
                    }
                ]
            },
            credits: { enabled: false },
            series: [
                {
                    name: 'Вовлечённость',
                    data: [involvementEr],
                    dataLabels: {
                        format: '{y} %',
                        borderWidth: 0,
                        color: colorText,
                        style: {
                            fontSize: '16px'
                        }
                    },
                    dial: {
                        radius: '80%',
                        backgroundColor: 'gray',
                        baseWidth: 12,
                        baseLength: '0%',
                        rearLength: '0%'
                    },
                    pivot: {
                        backgroundColor: 'gray',
                        radius: 6
                    }
                }
            ]
        }
    }, [involvementEr, colorBgElevated, colorText, title, height])

    return (
        <div className="w-full">
            <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
    )
}
